/**
 * Query keys for env-service state, keyed by the env locale code ("en-US", "fr").
 * The server prefetch and `useIntl().locale` both use that code, so hydration hits.
 */
export const environmentKeys = {
  activityCategories: (locale: string) =>
    ["environment", "activity-categories", locale] as const,
  activityKeywords: (locale: string) =>
    ["environment", "activity-keywords", locale] as const,
  web: (locale: string) => ["environment", "web", locale] as const,
};
